import React from 'react';
import { List, Datagrid, TextField,
    EditButton, Edit, SimpleForm, TextInput,
    required } from 'react-admin';
import SchoolIcon from '@material-ui/icons/Domain';

import { EditToolbar, EditAside } from './ui_components';

const SchoolList = props => (
  <List {...props}  bulkActionButtons={false} exporter={false} >
    <Datagrid>
      <TextField source="name" />
      <TextField source="classification" />
      <TextField source="max_supervisors" />
      <TextField source="max_players" />
      <EditButton />
    </Datagrid>
  </List>
);

const SchoolEdit = props => (
  <Edit {...props} undoable={false} aside={<EditAside />}>
    <SimpleForm toolbar={<EditToolbar />} redirect='edit'>
      <TextInput source="name" validate={[required()]} style={{ width: '100%' }}/>
      <TextInput source="address" multiline validate={[required()]} style={{ width: '100%' }}/>
      <TextField source="classification" />
      <TextField source="max_supervisors" />
      <TextField source="max_players" />
    </SimpleForm>
  </Edit>
);

export default {
  list: SchoolList,
  edit: SchoolEdit,
  icon: SchoolIcon,
};
